import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import clsx from 'clsx';

import { useTranslations } from 'components/utilities';
import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';

import heroImg from 'assets/images/arrivalsHeroImg.png';
import { configurationSelectors } from 'store/selectors';
import { Header } from './Header';

function Arrival() {
	const { t } = useTranslations();
	const classes = useStyles();

	const { isLoading, item } = useSelector(configurationSelectors.getAll);
	const url = `/cars/${item.airportUuid}`;

	return (
		<>
			<Box className={classes.container}>
				<Box className={classes.wrapper}>
					<Header />
					<Typography className={classes.subtitle}>
						{t('arrival.subHeader1')}
					</Typography>
					<Typography className={clsx([classes.subtitle, classes.subtitle2])}>
						{t('arrival.subHeader2')}
					</Typography>

					<Box className={classes.imgContainer}>
						<img className={classes.heroImg} src={heroImg} alt="rent a car" />
					</Box>

					{!isLoading && (
						<Link to={url} className={classes.link}>
							<Button
								className={classes.startButton}
								variant="contained"
								color="primary"
							>
								{t('arrival.button')}
							</Button>
						</Link>
					)}
				</Box>
			</Box>
		</>
	);
}

export default Arrival;
